import {
  AutoRefreshTokenService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  type IncludeBearerTokenCondition,
  UserActivityService,
  withAutoRefreshToken,
  ProvideKeycloakOptions,
} from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import { AppConfig, hasConfiguredString } from '../../shared/utils/app-config.util';

function normalizeCmsApiBaseUrl(base: string): string {
  return base.trim().replace(/\/+$/, '');
}

function cmsApiBaseUrlForBearerPattern(config: AppConfig): string {
  const raw = hasConfiguredString(config.API_CMS_URL)
    ? config.API_CMS_URL
    : environment.endpointBasePaths.cmsApiUrl;
  return normalizeCmsApiBaseUrl(raw);
}

/** RegExp for includeBearerTokenInterceptor — must match runtime CMS base from environment.json when set. */
export function buildCmsApiUrlPattern(config: AppConfig): RegExp {
  const base = cmsApiBaseUrlForBearerPattern(config);
  const escaped = base.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
  return new RegExp(`^${escaped}($|/)`);
}

export function initializeKeycloak(config: AppConfig): ProvideKeycloakOptions {
  return {
    config: {
      url: config.KEYCLOAK_URL === '' ? environment.keycloak.url : config.KEYCLOAK_URL,
      realm: config.KEYCLOAK_REALM === '' ? environment.keycloak.realm : config.KEYCLOAK_REALM,
      clientId: config.KEYCLOAKCLIENT_ID === '' ? environment.keycloak.clientId : config.KEYCLOAKCLIENT_ID,
    },
    initOptions: {
      onLoad: 'login-required',
      checkLoginIframe: false,
      redirectUri: `${globalThis.location.origin}/`,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout:
          config.KEYCLOAK_SESSION_TIMEOUT > 0
            ? config.KEYCLOAK_SESSION_TIMEOUT
            : environment.keycloak.sessionTimeout,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [{ urlPattern: buildCmsApiUrlPattern(config) }] as IncludeBearerTokenCondition[],
      },
    ],
  };
}

